export const PATH_SEGMENTS = {
  RETAILERS: 'retailers',
  RETAILER: 'retailer',
  CATEGORY_KEY: 'category',
  CATEGORY: 'shop',
  PRODUCT_DETAIL: 'product',
  SEARCH_RESULT: 'search',
  HOME_RETURN: 'return-app/',
  BLOG_SEARCH: 'blogsearch',
  RETAILER_STORE_ROUTE: 'retailerstore',
  BLOG: 'blog',
  BLOGS: 'blogs',
  BLOG_CATEGORY: 'category',
  CONTENTFUL_HOME: 'contentful-home',
  RETAILER_STORES_ROUTE: 'retailerstores',
  RETAILER_HANDOFF: 'retailerhandoff',
};

export const ROUTES = {
  RETAILERS_ROUTE: `/${PATH_SEGMENTS.RETAILERS}`,
  CATEGORY_ROUTE: `/${PATH_SEGMENTS.CATEGORY}`,
  PRODUCT_DETAIL_ROUTE: `/${PATH_SEGMENTS.PRODUCT_DETAIL}`,
  SEARCH_RESULT_ROUTE: `/${PATH_SEGMENTS.SEARCH_RESULT}`,
  HOME_ROUTE: '/',
  BLOG_SEARCH_RESULT_ROUTE: `/${PATH_SEGMENTS.BLOG_SEARCH}`,
  BLOG_ROUTE: `/${PATH_SEGMENTS.BLOG}`,
  BLOGS_ROUTE: `/${PATH_SEGMENTS.BLOGS}`,
  BLOG_SEARCH_CATEGORY_ROUTE: `/${PATH_SEGMENTS.BLOG_SEARCH}/${PATH_SEGMENTS.BLOG_CATEGORY}`,
  RETAILER_STORE_ROUTE: `/${PATH_SEGMENTS.RETAILER_STORE_ROUTE}`,
  CONTENTFUL_HOME_ROUTE: `/${PATH_SEGMENTS.CONTENTFUL_HOME}`,
  RETAILER_HANDOFF_ROUTE: `/${PATH_SEGMENTS.RETAILER_HANDOFF}`,
};
